import { axios } from '@/utils/request'

export default {
    create(input){
        return axios.post('/api/services/app/Lesson/Create',input)
    },
    update(input){
        return axios.put('/api/services/app/Lesson/Update',input)
    },
    delete(id){
        return axios.delete('/api/services/app/Lesson/Delete?Id='+id)
    },
    get(id){
        return axios.get('/api/services/app/Lesson/Get?Id='+id)
    },
    getAll(page){
        return axios.get('/api/services/app/Lesson/GetAll',{params:page})
    },
    getBaseInfos(input){
        return axios.get('/api/services/app/Lesson/GetBaseInfos',{params:input})
    },
    getSchools(){
        return axios.get('/api/services/app/Lesson/GetSchools')
    }
}